import { Route, Switch, Redirect } from "react-router-dom";
import { SessionInfoProvider } from "../contexts/SessionsContext";

import Footer from "./Footer";

import PrivacyPage from "../pages/Privacy";
import TosPage from "../pages/Tos";
import Sidebar from "../components/Sidebar";
import NewSidebar from "../components/NewSidebar";
import { Content, Scaffold } from "./PageStructure";
import MentorsPage from "../pages/MentorsPage";
import Outreach from "../pages/Outreach";
import OverviewPage from "../pages/OverviewPage";
import LoginPage from "../pages/LoginPage";
import { useEffect, useState } from "react";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import { PropagateLoader } from "react-spinners";
import MeetingRequests from "../pages/MeetingRequests";
import InsightsPage from "../pages/InsightsPage";
import CallOverviewPage from "../pages/CallOverviewPage";

import { useGlobalContext } from "../contexts/GlobalContext";
import ManagePage from "../pages/ManagePage";
import NewDashboard from "../pages/NewDashboard";
import EmailDashboardPage from "../pages/EmailDashboardPage";
import VideoEngagementPage from "../pages/VideoEngagementPage";
import VideoWorkshop from "../pages/video-workshop";
import ISRCCallsPage from "../pages/ISRCCallsPage";

function App() {
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const [state] = useGlobalContext();

    useEffect(() => {
        localStorage.setItem("user", JSON.stringify(state.user));
        if (!state.user) history.push("/login");
        // Redirect isrc users to isrc-calls page if not already there
        if (state.user?.privilege === "isrc" && window.location.pathname !== "/leads" && window.location.pathname !== "/login" && window.location.pathname !== "/forgot-password") {
            history.push("/leads");
        }
        setLoading(false);
    }, [state.user, history]);

    if (loading)
        return (
            <Loading>
                <PropagateLoader color="#b200f1" />
            </Loading>
        );

    return (
        <div className="App">
            <SessionInfoProvider>
                <Switch>
                    <Route exact path="/">
                        <WithNewSidebar>
                            <NewDashboard />
                        </WithNewSidebar>
                    </Route>
                    <Route exact path="/login">
                        <LoginPage />
                    </Route>
                    <Route exact path="/forgot-password">
                        <ForgotPasswordPage />
                    </Route>
                    <Route path="/mentors">
                        <WithNewSidebar>
                            <MentorsPage />
                        </WithNewSidebar>
                    </Route>
                    <Route exact path="/insights">
                        <WithNewSidebar>
                            <InsightsPage />
                        </WithNewSidebar>
                    </Route>

                    <Route exact path="/meeting-requests">
                        <WithNewSidebar>
                            <MeetingRequests />
                        </WithNewSidebar>
                    </Route>
                    <Route exact path="/outreach">
                        <WithSidebar>
                            <Outreach />
                        </WithSidebar>
                    </Route>
                    <Route path="/manage">
                        <WithSidebar>
                            <ManagePage />
                        </WithSidebar>
                    </Route>
                    <Route exact path="/newDashboard">
                        <WithNewSidebar>
                            <NewDashboard />
                        </WithNewSidebar>
                    </Route>
                    <Route exact path="/privacy">
                        <WithSidebar>
                            <PrivacyPage />
                            <Footer />
                        </WithSidebar>
                    </Route>
                    <Route exact path="/tos">
                        <WithSidebar>
                            <TosPage />
                            <Footer />
                        </WithSidebar>
                    </Route>
                    <Route exact path="/callOverview">
                        <WithNewSidebar>
                            <CallOverviewPage />
                        </WithNewSidebar>
                    </Route>
                    {state.user?.privilege === "isrc" && (
                        <Route exact path="/leads">
                            <WithNewSidebar>
                                <ISRCCallsPage />
                            </WithNewSidebar>
                        </Route>
                    )}
                    {(state.user?.privilege === "boston" ||
                        state.user?.privilege === "GW Law" ||
                        state.user?.privilege === "usc" ||
                        state.user?.privilege === "UNH Law") && (
                        <Route exact path="/email">
                            <WithNewSidebar>
                                <EmailDashboardPage />
                            </WithNewSidebar>
                        </Route>
                    )}
                    {state.user?.privilege === "admin" && (
                        <Route exact path="/video-engagement">
                            <WithNewSidebar>
                                <VideoEngagementPage isAdmin={state.user?.privilege === "admin"} universityId={state.user?.privilege} />
                            </WithNewSidebar>
                        </Route>
                    )}
                    {state.user?.privilege === "admin" && (
                        <Route exact path="/video-workshop">
                            <WithNewSidebar>
                                <VideoWorkshop />
                            </WithNewSidebar>
                        </Route>
                    )}

                    {/* <Route>
                        <Redirect to="/" />
                    </Route> */}
                </Switch>
            </SessionInfoProvider>
        </div>
    );
}

const WithSidebar = ({ children }) => {
    return (
        <Scaffold>
            <Sidebar />
            <Content>{children}</Content>
        </Scaffold>
    );
};

const WithNewSidebar = ({ children }) => {
    return (
        <Scaffold>
            <NewSidebar />
            <Content>{children}</Content>
        </Scaffold>
    );
};

export default App;
